import { call } from 'redux-saga/effects'
import reqProvider from '../coreRequests'
import { DATA_API } from '../urlPaths'

export function* getCountryList(): any {
  const path = `${DATA_API}/results?contextName=.energy.countries&limit=999`
  const data: any = yield call(reqProvider.getReq, path)
  return data ?? []
}
